module.exports = __webpack_public_path__ + "static/media/service-9_old.03b476bd.jpg";